import { Dialog } from "primereact/dialog";
import { useMemoryHitUptime } from "../../Hooks/Features/Inspectra/useMemoryHitUptime";
import { SkeletonContainer } from "../Loader/Loader";
import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts';
import Highcharts3D from "highcharts/highcharts-3d";
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
Highcharts3D(Highcharts);

const UptimeTrend = ({ autopopData, projectChanged }) => {

    const widget = "uptime";
    const { filterCount, loader, showFilter, setShowFilter, filterValues, setFilterValues, showPopup, setShowPopup, popupData, expand, setExpand, allUptimeOptions, handleApplyFilters } = useMemoryHitUptime({ autopopData, widget, projectChanged });

    return (
        <div className="inspectra-widget-container">
            <div className="p-2 d-flex justify-content-between align-items-center">
                <div className="inspectra-widget-header">Uptime Trend</div>
                <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center" onClick={() => setShowFilter(true)}><span className="inspectra-filter-count">{filterCount}</span>filters</div>
            </div>
            <div className="inspectra-widget-content d-flex flex-wrap gap-2">
                {loader ? <SkeletonContainer /> : (
                    allUptimeOptions.length > 0 && allUptimeOptions?.map((options, idx) => {
                        const sizeClass = options.chartSize === 'large' ? 'chart-large' : options.chartSize === 'medium' ? 'chart-medium' : 'chart-small';
                        return (
                            <div key={idx} style={{ overflowY: "auto" }} className={sizeClass}>
                                <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} />
                            </div>
                        )
                    }))
                }
                <div className="inspectra-expand-icon fs-6 c-pointer" onClick={() => setExpand(true)}>
                    <FontAwesomeIcon icon="fa-solid fa-expand" />
                </div>
            </div>

            <Dialog visible={showFilter} onHide={() => setShowFilter(false)} className="modal-small" draggable={false} header="Uptime Trend Filters">
                <div>
                    <div className="d-flex gap-2">
                        <div className="w50">
                            <div>Service:</div>
                            <MultiSelect options={autopopData?.service_name} placeholder="Service" value={filterValues?.service} onChange={(e) => setFilterValues((prev) => ({ ...prev, service: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'service', filterValues?.service, () => setFilterValues((prev) => ({ ...prev, service: [] })))} filter filterInputAutoFocus />
                        </div>
                        <div className="w50">
                            <div>Server:</div>
                            <MultiSelect options={autopopData?.server} placeholder="Server" value={filterValues?.server} onChange={(e) => setFilterValues((prev) => ({ ...prev, server: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'server', filterValues?.server, () => setFilterValues((prev) => ({ ...prev, server: [] })))} filter filterInputAutoFocus />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="text-primary c-pointer" onClick={() => setFilterValues((prev) => ({ ...prev, service: [], server: [] }))}>Select default filters</div>
                        <button className="button btn-primary" onClick={() => handleApplyFilters()}>Apply</button>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={showPopup} onHide={() => { setShowPopup(false); }} draggable={false} className="modal-large inspectra-grey-dialog" header="Uptime Trend Details">
                <div>
                    <div className="service-error-list">
                        {popupData?.map((item, index) => (
                            <div key={index} className="service-error-item">
                                <div className="d-flex gap-5">
                                    <div><strong>Project:</strong> {item?.project_name}</div>
                                    <div><strong>Service Type:</strong> {item?.service_type}</div>
                                    <div><strong>Service:</strong> {item?.service_name}</div>
                                </div>
                                <div><strong>Server:</strong> {item?.server}</div>
                                <div><strong>Uptime:</strong> {item?.uptime_mins} min.</div>
                            </div>
                        ))}
                    </div>
                </div>
            </Dialog>

            <Dialog visible={expand} onHide={() => setExpand(false)} className="modal-xlarge" draggable={false} header="Uptime Trend Expanded">
                <div>
                    <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center justify-content-end" onClick={() => setShowFilter(true)}>
                        <span className="inspectra-filter-count">{filterCount}</span>filters
                    </div>
                    <div className="inspectra-widget-content d-flex flex-wrap gap-2">
                        {loader ? <SkeletonContainer /> : (
                            allUptimeOptions.length > 0 && allUptimeOptions?.map((options, idx) => {
                                const sizeClass = options.chartSize === 'large' ? 'chart-large' : options.chartSize === 'medium' ? 'chart-medium' : 'chart-small';
                                return (
                                    <div key={idx} style={{ overflowY: "auto" }} className={sizeClass}>
                                        <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} />
                                    </div>
                                )
                            }))
                        }
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default UptimeTrend;